module.exports = __webpack_public_path__ + "static/media/covidtracker.8ba46b28.png";